export default "__VITE_ASSET__MMMQfS9L__"